import React, { useState } from "react";
import { StickyContainer, Sticky } from "react-sticky";
import { Link } from "react-router-dom";

//COMPONENTS
import HoneycombImg from "./HoneycombImg";

const services = [
  {
    to: "/business-advisory",
    title: "Business Advisory",
    text: "We offer consulting services for start-ups, administrative support, operational and tax management for daily operations as well as specific tailored cases.",
  },
  {
    to: "/investment-acquisition",
    title: "Investment & Acquisition",
    text: "Dedicated to the creation, support and development of new businesses and existing businesses through our acquisition and investment opportunities.",
  },
  {
    to: "/payroll",
    title: "Payroll",
    text: "Payroll should be something you don't need to think about. You just need your staff to be paid the right amount every time. We have designed our processes to guarantee that.",
  },
  {
    to: "/hr-solutions",
    title: "HR Solutions",
    text: "A company's most valuable asset is its employees. The services we provide are completely individualised to your business - we will never give you a 'one size fits all' contract, handbook or policy. This means that we will provide tailored HR solutions that are specific to your goals and gives you complete peace of mind that your legal obligations are covered.",
  },
];

const ServicesLaptop = () => {
  const [bottomOffsetTitle, setBottomOffsetTitle] = useState();
  const [leftPositionHoneyComb, setLeftPositionHoneycomb] = useState();

  return (
    <StickyContainer className="hidden lg:block">
      <Sticky bottomOffset={bottomOffsetTitle}>
        {({ style }) => (
          <h2 style={style} className="bg-white header2 py-20 text-center">
            Our <span className="text-earth">Services</span>
          </h2>
        )}
      </Sticky>

      <div className="grid grid-cols-2 gap-12 xl:gap-24">
        <div
          className="relative"
          style={{ left: "-" + leftPositionHoneyComb + "px" }}
        >
          <Sticky bottomOffset={160}>
            {({ style, isSticky }) => (
              <div style={style} className={`pt-${isSticky ? 48 : 0}`}>
                <HoneycombImg
                  isSticky={isSticky}
                  setBottomOffsetTitle={setBottomOffsetTitle}
                  setLeftPositionHoneycomb={setLeftPositionHoneycomb}
                  bottomOffsetTitle={bottomOffsetTitle}
                />
              </div>
            )}
          </Sticky>
        </div>

        <div className="grid grid-rows-4 items-center overflow-hidden my-20">
          {services.map((item) => (
            <div key={item.title} className="my-40 mr-20 max-w-3xl">
              <Link
                to={item.to}
                className="text-3xl font-medium text-darkBlue hover:text-earth"
              >
                <h3>
                  {item.title} <span className="text-earth ml-4">&rarr;</span>
                </h3>
              </Link>
              <p className="text-lightBlue mt-4">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </StickyContainer>
  );
};

export default ServicesLaptop;
